import { INITIAL_DATA_LOADED } from '../actions/CompoundFetchActions';
import Mutation from '../models/Mutation';

const initialState = {
	items: [],
	loaded: false
};

export default class MutationsReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 * @return {{items: Array, loaded: boolean}}
	 */
	static reduce(state = initialState, action) {
		switch (action.type) {
			// If initial data was loaded, we want to load our currencies
			case INITIAL_DATA_LOADED:
				return MutationsReducer.normalize({
					...state,
					items: action.mutations,
					loaded: true
				});
			default:
				return state;
		}
	}

	/**
	 * @param {object} state
	 * @return {*}
	 */
	static normalize = (state) => ({
		...state,
		items: state.items.map((mutation) => Mutation.normalize(mutation))
	});
}


// WEBPACK FOOTER //
// ./reducers/MutationsReducer.js